<template>
  <div id="social-icons">
    <a v-for='linkObj in socialData' :key='linkObj.name' :href='linkObj.url' target='_new'>
      <img :src='"../assets/" + linkObj.name + "_icon.png"'>
    </a>
  </div>
</template>

<script>
export default {
  name: "social",
  data() {
    return {
      socialData: [
        {
          name: "twitter",
          url: "https://twitter.com/amayumi_maki"
        },
        {
          name: "pixiv",
          url: "https://www.pixiv.net/member.php?id=581175"
        },
        {
          name: "fanbox",
          url: "https://www.pixiv.net/fanbox/creator/581175"
        },
        {
          name: "niconico",
          url: "http://www.nicovideo.jp/mylist/62423676"
        },
        {
          name: "youtube",
          url: "https://www.youtube.com/playlist?list=PLQZzJZCW_ohneyHTsaosyM58-8jE5xtYk"
        },
        {
          name: "suzuri",
          url: "https://suzuri.jp/amayumi_maki"
        }
      ]
    };
  }
};
</script>

<style>
#social-icons {
  display: inline-flex;
  margin: 0 1em 0 auto;
}
#social-icons a {
  margin: 0 0.5em;
}

</style>



// WEBPACK FOOTER //
// src/components/Social.vue